import { useTranslation } from 'react-i18next';
import { Button } from 'antd';

import { Ok, Pencil } from 'icons';

import styles from './EditorButtons.module.scss';

interface Props {
  isEditMode: boolean;
  onEditClick: () => void;
  onCancelClick?: () => void;
  onSaveClick?: () => void;
  editLabel?: string;
  disabledSave?: boolean;
  id?: string;
}

export const EditorButtons = ({
  isEditMode,
  onEditClick,
  onCancelClick,
  onSaveClick,
  editLabel,
  disabledSave,
  id,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonsContainer}>
      {!isEditMode ? (
        <Button type="primary" onClick={onEditClick} icon={<Pencil />}>
          {editLabel || t('edit')}
        </Button>
      ) : (
        <>
          <Button onClick={onCancelClick}>{t('cancel')}</Button>
          <Button
            onClick={onSaveClick}
            disabled={disabledSave}
            type="primary"
            htmlType="submit"
            form={id}
            icon={<Ok />}
          >
            {t('saveChanges')}
          </Button>
        </>
      )}
    </div>
  );
};
